import { gql } from '@apollo/client';

export const READ_VERIFIED_EXTERNAL_ATTRIBUTE = gql`
  query ReadVerifiedExternalAttribute(
    $email: String!
    $externalVerificationType: ExternalVerificationType!
  ) {
    readVerifiedExternalAttribute(
      email: $email
      externalVerificationType: $externalVerificationType
    ) {
      id
      customerUid
      status
    }
  }
`;
